import React from "react";
import { Row, Col } from 'react-bootstrap';
import LineHorizontal from '../components/LineHorizontal.js'

export default class Clients extends React.Component {
  render() {
    return (
    	<Row>
    		<Col md={12}>
          <h2 className="text-center">Clients</h2>
    		</Col>
        <Col md={12}>
          <LineHorizontal/>
        </Col>
        <Col md={10} mdOffset={1}>
          <p>Crowtech have been designing equipment and software for many clients over the years. He has designed and worked on products such as:</p>
        </Col>
        <Col md={5} mdOffset={1}>
          <ul>
            <li>Race Car Timing Systems  (these were used at Indianapolis and all Australian CAMS races)</li>
            <li>DSP Development systems</li>
            <li>Smash Repair Camera Systems</li>
            <li>NEC Microcontroller Emulators</li>
            <li>Poker Machine Jackpot Controller Systems</li>
            <li>Atari ST time clocks</li>
            <li>Embedded System Water boards (with his own real-time, concurrent operating system)</li>
            <li>High accuracy rubber rulers (that can measure tree girth growth rates)</li>
            <li>Software based Mosquito Repellers</li>
            <li>Voice Synthesis systems for the disabled</li>
            <li>Switch Mechanisms for the disabled</li>
            <li>Air traffic control systems</li>
            <li>Mobile Phone software</li>
            <li>3D laser scanning Systems</li>
            <li>Barcoding systems</li>
            <li>Online Freight Management Software</li>
            <li>World wide VOIP systems</li>
            <li>Embedded VOIP systems</li>
            <li>Wireless ISDN FEC systems</li>
            <li>Voice processing embedded systems</li>
          </ul>
        </Col>
        <Col md={5}>
          <ul>
            <li>Truck Tracking systems</li>
            <li>Rock crushing systems</li>
            <li>Metal Detector using DSP.</li>
            <li>PC Motherboards</li>
            <li>Electrical Power Switching systems</li>
            <li>Auto Keyboard assistance for the disabled</li>
            <li>CRM systems for business management groups</li>
            <li>Network Traffic monitoring</li>
            <li>PC and Windows Server Support</li>
            <li>Linux monitoring and management systems using JEE and Rules engines</li>
            <li>Microcontroller based Dice systems</li>
            <li>Windows based Smash Repair Work Scheduling Systems</li>
            <li>Underground Fuel Storage Data Processing Systems</li>
            <li>Superannuation Software</li>
            <li>Multi Client Database Integration Portals</li>
            <li>Prisoner Transport Software</li>
            <li>Hotel Management Software</li>
            <li>Online Timesheet systems</li>
            <li>Online Recruitment Systems</li>
            <li>Online Real Estate Systems</li>
            <li>Linux Servers</li>
          </ul>
        </Col>
        <Col md={10} mdOffset={1}>
          <p>He has also consulted to many companies and written board level reports in the Telecoms, Finance and Property industries.</p>
          <p>He has led many teams over the years. His largest was at Telstra where he was promoted to team leader of the Phoenix Project with 18 software engineers under his command.</p>
        </Col>
    	</Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/pages/Clients.js